import get from 'lodash/get';
import { RouteConfig } from 'found';

export function getActiveCrawlerCategory (routes: RouteConfig[]): string | undefined {
  return get(routes, ['3', 'path'], '');
}

export function getActiveCrawlerSection (routes: RouteConfig[]): string | undefined {
  return get(routes, ['4', 'path'], '');
}
